import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/bradenton_florida_1600.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image41.webp';
import slideImg2 from '../images/image95.webp';
import slideImg3 from '../images/image42.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const ruboniaConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Rubonia Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Rubonia, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_rubonia',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Rubonia',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Rubonia Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring professional tree care to the 
     residential properties and rural stretches of <strong>Rubonia</strong>. This 
     community along the upper reaches of Tampa Bay sees serious wind and storm exposure, 
     and the trees here grow large and fast. When a storm leaves behind split trunks, 
     leaning palms, or limbs hanging over your home, our team responds with the 
     experience and equipment to get the job done right.`,

    `We specialize in <strong>dangerous tree removal and trimming</strong> tackling 
     storm damaged trees, overgrown canopies pressing against structures, trees leaning 
     toward homes or fences from waterlogged soil, and large limb removal that requires 
     careful rigging and precision. We take pride in working safely on every property 
     we service.`,

    `<strong>Sam's Tree Service</strong> offers dependable, expert tree care throughout 
     <strong>Rubonia</strong> and the surrounding <strong>North Manatee County</strong> 
     communities keeping your property protected and your landscape healthy no matter 
     the season.`,
  ],

  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Rubonia, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Rubonia = () => <LocationPage config={ruboniaConfig} />;
export default Services_Rubonia;
